// This file defines the operators used in the Query Builder!
import { defaultOperators } from "react-querybuilder";

const numericOperators = [
  { name: "=", label: "=" },
  { name: "!=", label: "!=" },
  { name: "<", label: "<" },
  { name: ">", label: ">" },
  { name: "<=", label: "<=" },
  { name: ">=", label: ">=" },
];

const textOperators = [
  { name: "=", label: "is" },
  { name: "!=", label: "is not" },
  { name: "contains", label: "contains" },
  { name: "beginsWith", label: "begins with" },
  { name: "endsWith", label: "ends with" },
  { name: "doesNotContain", label: "does not contain" },
  { name: "doesNotBeginWith", label: "does not begin with" },
  { name: "doesNotEndWith", label: "does not end with" },
  { name: "null", label: "is blank" },
  { name: "notNull", label: "is not blank" },
];

const selectOperators = [
  { name: "=", label: "is" },
  { name: "!=", label: "is not" },
  { name: "null", label: "is blank" },
  { name: "notNull", label: "is not blank" },
];

const dateOperators = [
  { name: "=", label: "is" },
  { name: "!=", label: "is not" },
  { name: "<", label: "is before" },
  { name: ">", label: "is after" },
  { name: "<=", label: "is on or before" },
  { name: ">=", label: "is on or after" },
];

const getOperators = (field) => {
  switch (field) {
    case "row":
    case "gradePointAverage":
      return numericOperators;
    case "jhed":
    case "firstName":
    case "lastName":
    case "program":
    case "refereeName":
    case "course1":
    case "course2":
    case "course3":
    case "course4":
    case "hiredFor":
    case "preferredName":
      return textOperators;
    case "term":
    case "status":
    case "evaluation":
    case "adminFeedback":
    case "classYear":
    case "experience":
    case "enrollmentStatus":
    case "residency":
    case "workStudy":
    case "payroll":
    case "grade1":
    case "grade2":
    case "grade3":
    case "grade4":
    case "experience1":
    case "experience2":
    case "experience3":
    case "experience4":
    case "head1":
    case "head2":
    case "head3":
    case "head4":
    case "instructorFeedback1":
    case "instructorFeedback2":
    case "instructorFeedback3":
    case "instructorFeedback4":
      return selectOperators;
    case "year":
    case "createdAt":
      return dateOperators;
    default:
      return defaultOperators;
  }
};

export default getOperators;
